import { PayloadAction } from "@reduxjs/toolkit";
import { HOME_TYPE } from "@/components/PageHome/api/interface";
import { FlowData, HomeDataType, HomeState } from "@/components/PageHome/redux/types";

const HomeReducer = {
  setCurrentFlow: (state: HomeState, action: PayloadAction<`${HOME_TYPE}`>) => {
    state.currentFlow = action.payload;
  },

  setFlowData: (state: HomeState, action: PayloadAction<FlowData>) => {
    state.flowData = action.payload;
  },

  setHomeData: (state: HomeState, action: PayloadAction<HomeDataType>) => {
    state.homeData = action.payload;
  },

  clearFlowData: (state: HomeState) => {
    state.flowData = undefined;
    state.currentFlow = undefined;
    state.loading = false;
  },
  setLoading: (state: HomeState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },

  setError: (state: HomeState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
};

export default HomeReducer;
